import { h } from 'preact'
import Icon from '../assets'

export const ExternalLink = ({ label, url } : { label: string, url: string }) => (
  <div className='how-to-with-icon'>
    <a href={url} target='_blank'>
      <span className='how-to-link'> {label}</span>
      <Icon customClass={'icon-open-in-new'} icon={'openInNew'} width={12} height={12} />
    </a>
  </div>
)
